module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/conditioner_627d12.png";